// @flow

import React, { type Element } from 'react'
import { Grid, Box, Typography } from '@material-ui/core'
import grey from '@material-ui/core/colors/grey'
import DeleteIcon from '@material-ui/icons/Delete'
import type { PrivateFacility } from '../types'

type Props = {|
  facility: PrivateFacility,
  deleteFacility: (string) => void,
|}

function FacilityItem({ facility, deleteFacility }: Props): Element<typeof React.Fragment> {
  return (
    <Box width={1} pt={2} key={facility.code}>
      <Grid container justify="space-between">
        <Box my="auto" color={grey[900]} fontWeight="fontWeightMedium">
          <Typography component="span" variant="body2">
            {facility.name}:{' ' + facility.code}
          </Typography>
        </Box>
        <Box
          display="flex"
          style={{ cursor: 'pointer' }}
          onClick={() => deleteFacility(facility.id)}
        >
          <DeleteIcon style={{ color: grey[600] }} />
          <Box pl={0.5} color={grey[600]} fontWeight="fontWeightMedium" my="auto">
            <Typography component="span" variant="body2">
              Remove
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Box>
  )
}

export default FacilityItem
